import React, {useState} from 'react';
import PropTypes, {InferProps} from 'prop-types';
import {OnboardingCatalogContext} from 'context';
import {EfeCatalog, EfeCatalogValue} from 'commons/models';
import {CATALOGS_TO_ORDER} from 'commons/constants';

const defaultContextValue = {
    catalogs: [],
};

/**
 * Onboarding Flow Context Provider
 * @param {InferProps<typeof EfeCatalogProvider.propTypes>} props
 * @returns {JSX.Element}
 * @constructor
 */
function EfeCatalogProvider(props: InferProps<typeof EfeCatalogProvider.propTypes>) {
    const {children} = props;
    const [catalogs, setCatalogs] = useState<Array<EfeCatalog>>(defaultContextValue.catalogs);

    function orderCatalog(data: Array<EfeCatalogValue>): Array<EfeCatalogValue> {
        return data.sort((a, b) => a.order - b.order);
    }

    const updateCatalogs = (data: EfeCatalog) => {
        const temp = [...catalogs];
        temp.push({...data});
        setCatalogs([...temp]);
    };

    const uploadData = (data: Array<EfeCatalog>) => {
        data.forEach((catalog) => {
            if (CATALOGS_TO_ORDER.findIndex((item) => item === catalog.name) > -1) {
                catalog.values = orderCatalog(catalog.values);
            }
        });
        setCatalogs([...data]);
    };

    return (
        <OnboardingCatalogContext.Provider
            value={{
                catalogs,
                updateCatalogs,
                uploadData,
            }}>
            {children}
        </OnboardingCatalogContext.Provider>
    );
}

EfeCatalogProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default EfeCatalogProvider;
